<loading-screen [displayed]="!allEvents?.length" [templateType]="'GENERIC'"></loading-screen>
@if (allEvents?.length) {
    <accordion
        [accordionTitle]="sectionTitle"
        [isExpanded]="true"
        (function)="sendCollapseGTM()"
        data-crlat="outerAccordion"
        class="extra-place-carousel-section"
        [ngClass]="{ sectionExpanded: isEventOverlay, outerAccordionFeatured: isRacingFeatured }">
        <accordion-body data-crlat="race.enhancedRacesCarousel">
            @for (key of raceKeys; track $index) {
                @if (!isEventOverlay && groupedEvents[key]?.events?.length) {
                    <div
                        [ngCarousel]
                        [ngCarouselAmount]="slidesOnPage"
                        [ngCarouselName]="key"
                        [ngCarouselLoop]="false"
                        [ngCarouselWatch]="groupedEvents[key]?.events?.length"
                        [attr.data-crlat]="groupedEvents[key].title"
                        class="extra-place-carousel ng-carousel">
                        <div class="carousel-inner" [ngClass]="{ 'single-slide': groupedEvents[key].events.length === 1 }">
                            <slidecontainer class="carousel-slides">
                                @for (event of groupedEvents[key].events; track trackById(i, event); let i = $index) {
                                    <slide class="slide" data-crlat="raceCard.event">
                                        <div class="carousel-slide">
                                            <div class="slide-label">
                                                <div class="title" data-crlat="raceCard.title" [textContent]="groupedEvents[key].title"></div>
                                                <div class="timer" data-crlat="raceCard.timer">
                                                    <race-timer [event]="event" [utc]="true" [displayTime]="false"></race-timer>
                                                </div>
                                            </div>
                                            <a (click)="goToEvent(event)" [linkHref] [link]="event.link" class="slide-body">
                                                <div class="selection-title">
                                                    <div
                                                        class="meeting-name"
                                                        [textContent]="event.originalName"
                                                        data-crlat="raceCard.eventName"></div>
                                                    <lazy-component
                                                        moduleUri="@lazy-modules-module/extraPlaceSignposting/extra-place-signposting.module#ExtraPlaceSignpostingModule"
                                                        [inputs]="{
                                                            marketData: event.markets[0],
                                                            origin: 'offers',
                                                            changeStrategy: changeStrategy,
                                                            onChildModuleLoaded: onChildModuleLoaded,
                                                        }"
                                                        entryComponent="ExtraPlaceSignpostingComponent">
                                                    </lazy-component>
                                                    @if (event.odds) {
                                                        <div class="odds" [innerHTML]="event.odds" data-crlat="eachWayContainer"></div>
                                                    }
                                                </div>
                                                <svg class="next-arrow" data-crlat="nextArrow">
                                                    <use xlink:href="#next-arrow"></use>
                                                </svg>
                                            </a>
                                        </div>
                                    </slide>
                                }
                            </slidecontainer>
                        </div>
                    </div>
                }
                <!-- Below html content will display only in quick-navigation popup in horse racing event page (mobile)-->
                @if (isEventOverlay && groupedEvents[key]?.events?.length) {
                    <div class="tabs-panel tabs-bottom" data-crlat="panel.tabs">
                        <p class="sub-header" [textContent]="'EXTRA PLACE OFFERS'"></p>
                        <div class="scroll-container" [scrollable-racing]>
                            <ul class="scroll-inner scroll-panel">
                                @for (event of groupedEvents[key].events; track trackById(i, event); let i = $index) {
                                    <li data-crlat="raceCard.event">
                                        <a class="tab" (click)="goToEvent(event)" [linkHref] [link]="event.link" data-crlat="tab">
                                            <span class="race-time"><b [textContent]="event.localTime"></b></span>
                                            <span class="race-type" [textContent]="event.typeName.toLowerCase().substring(0, 4)"></span>
                                        </a>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                }
            }
        </accordion-body>
    </accordion>
}
